import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink, UiUserPreview } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationUsersBirthdays = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>День рождения</div>
            <div className={'vm-notification__description'}>
                <span>Поздравьте коллег! Сегодня празднуют день рождения:<br/></span>
                <div className='vm-notification__users'>
                    {notification.data.users.map(user => (
                        <UiNavLink to={ROUTES.USER(user.id)} className='vm-notification__user' key={user.id}>
                            <UiUserPreview value={user} />
                        </UiNavLink>
                    ))}
                </div>
            </div>
        </div>
    );
})
